module.exports = __webpack_public_path__ + "static/media/foodTruck.2e020d86.png";